import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType, LangContext, LangContextType, LoadingContext, LoadingContextType, ToastContext, ToastContextType, useRequiredParams } from "../../../utilities/customHooks"
import { useAsync } from "../../../utilities/customHooks";
import ErrorIndicator from "../../../Components/ErrorIndicator";
import LoadingIndicator from "../../../Components/LoadingIndicator";
import { applicationEditRequest, getMembershipApplicationDetails, getfounderDocuments, rejectionEmailTrigger, updateApplicationStatus, updateMemberDd, updateRejectionFlag, updatedRejectionProg } from "../../../services/adminService";
import ApproveReject from "../../../Components/Features/ApproveReject"
import * as T from "../../../utilities/frontendTypes";
import { convertFounderProfileDBStateToUIState } from "../../../utilities/stateConverters";
import ContentPageTopButtons from "../../../Components/ContentPageTopButtons";
import { DetailsContentHeader, detailsContentWrapperStyle } from "../ProfilePages/NewAdmin";
import textData from "../../../textData.json";
import { SetStateAction, useContext, useEffect, useState } from "react";
import PdfDownloader from '../../../Components/Form/pdfDisplay';
import Form from "../../../Components/Form/Form";
import { profileFormCompanyInfoDefinition, profileFormPersonalInfoDefinition, adminProfileFormProgramingEvaluationDefinition, profileFormiPStrategyDefinition, profileFormipReadinessDefinition } from "../../../utilities/profileFormDefitions";
import { flattenObject } from "../../../utilities/helperFunctions";
import Modal from "../../../Components/Modal";
import Button, { ButtonProp } from "../../../Components/Button";
import TextArea from "../../../Components/Input/TextArea";
import { inputClasses } from "../../../Components/Form/InputField";

function MemberApplicationDetail() {
  // const { langState } = useContext(LangContext) as LangContextType
  const { userRegion } = useContext(AuthContext) as AuthContextType; // [NOTE] This casting is intentional
  const langState = "eng"
  const [childClickedAccordionItemIndex, setChildClickedAccordionItemIndex] = useState(0);
  const applicationId = useRequiredParams("applicationId");
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const [viewPdfName, setViewPdfName] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalHTML, setModalHTML] = useState(<></>)
  const [reload, setReload] = useState(false)
  const [cat1dd, setCat1dd] = useState("")
  const [cat2dd, setCat2dd] = useState("")
  const [cat3dd, setCat3dd] = useState("")
  const [cat4dd, setCat4dd] = useState("")
  const [cat5dd, setCat5dd] = useState("")
  const [cat6dd, setCat6dd] = useState("")
  const [hardCrit, setHardCrit] = useState(false)
  const [notTech, setNotTech] = useState(false)
  const [economicBenefit, setEconomicBenefit] = useState(false)
  const [revScore, setRevScore] = useState(false)
  const [marketReadiness, setMarketReadiness] = useState(false)
  const [ipOwnership, setIpOwnership] = useState(false)
  const [commercialization, setCommercialization] = useState(false)
  const [jobCreation, setJobCreation] = useState(false)
  const [teamFit, setTeamFit] = useState(false)
  const [ddNote, setDdNote] = useState("")
  const [reasonNote, setReasonNote] = useState("");
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const [reapply, setReapply] = useState(false)
  const [nextStep, setNextStep] = useState("")
  const [isDdModalOpen, setIsDdModalOpen] = useState(false)
  const [isRejectionModalOpen, setIsRejectionlModalOpen] = useState(false)
  const [failTrue, setFailTrue] = useState(false)
  const [issueTrue, setIssueTrue] = useState(false)
  const [conditionalPassTrue, setConditionalPassTrue] = useState(false)
  const [checkDd, setCheckDd] = useState(false)

  const handleNextStepChange = (string: string) => {
    setNextStep(string);
  };

  useEffect(() => {
    const catArray = [cat1dd, cat2dd, cat3dd, cat4dd, cat5dd, cat6dd]
    console.log(catArray)
    if (catArray.includes("fail")) {
      setFailTrue(true)
      setConditionalPassTrue(false)
      setIssueTrue(false)
    } else if (catArray.includes("issue")) {
      setIssueTrue(true)
      setFailTrue(false)
      setConditionalPassTrue(false)
    } else if (catArray.includes("conditionalPass")) {
      setConditionalPassTrue(true)
      setFailTrue(false)
      setIssueTrue(false)
    } else {
      setIssueTrue(false)
      setFailTrue(false)
      setConditionalPassTrue(false)
    }
  }, [cat1dd, cat2dd, cat3dd, cat4dd, cat5dd, cat6dd]);

  const navigate = useNavigate();


  const membershipApplicationDetailsAsync = useAsync(() => getMembershipApplicationDetails(applicationId), [applicationId, reload]);

  const companyInfoToForm = (info: T.CompanyInfo) => {
    return flattenObject({basicInfo: info.basicInfo, mailingAddress: info.mailingAddress, registration: info.registration})
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setModalHTML(<></>)
  }

  const cat1Change = (event: { target: { value: SetStateAction<string>; }; }) => {
    setCat1dd(event.target.value);
  };

  const cat2Change = (event: { target: { value: SetStateAction<string>; }; }) => {
    setCat2dd(event.target.value);
  };

  const cat3Change = (event: { target: { value: SetStateAction<string>; }; }) => {
    setCat3dd(event.target.value);
  };

  const cat4Change = (event: { target: { value: SetStateAction<string>; }; }) => {
    setCat4dd(event.target.value);
  };

  const cat5Change = (event: { target: { value: SetStateAction<string>; }; }) => {
    setCat5dd(event.target.value);
  };

  const cat6Change = (event: { target: { value: SetStateAction<string>; }; }) => {
    setCat6dd(event.target.value);
  };

  const changeCriteria = (criteria: string) => {
    if (criteria === "hardCrit") {
      setHardCrit(!hardCrit)
    }
    if (criteria === "notTech") {
      setNotTech(!notTech)
    }
    if (criteria === "economicBenefit") {
      setEconomicBenefit(!economicBenefit)
    }
    if (criteria === "revScore") {
      setRevScore(!revScore)
    }
    if (criteria === "marketReadiness") {
      setMarketReadiness(!marketReadiness)
    }
    if (criteria === "ipOwnership") {
      setIpOwnership(!ipOwnership)
    }
    if (criteria === "hardCrit") {
      setHardCrit(!hardCrit)
    }
    if (criteria === "commercialization") {
      setCommercialization(!commercialization)
    }
    if (criteria === "jobCreation") {
      setJobCreation(!jobCreation)
    }
    if (criteria === "teamFit") {
      setTeamFit(!teamFit)
    }
  }

  async function failDd () {
    const ddObj = {
      cat1: cat1dd,
      cat2: cat2dd,
      cat3: cat3dd,
      cat4: cat4dd,
      cat5: cat5dd,
      cat6: cat6dd,
    }
    
    showLoading();
    const response = await updateMemberDd(ddObj, applicationDetails._id, false, ddNote);
    if (response.success) {
      const res = await updateApplicationStatus(applicationId, reasonNote, status, reapply, "membership");
      if (res.success) {
        showToast({
          toastType: "success",
          message: "Application Rejected",
        });
        navigate(`/dashboard/memberships/${applicationDetails._id}`);
      }
    }
      hideLoading();  
    }

    async function addRejectionFlag () {
    showLoading();
    const response = await updateRejectionFlag(applicationDetails._id);
      if (response.success) {
          showToast({
            toastType: "success",
            message: "Application Flagged for Rejection Processing",
          });
        navigate(`/dashboard/memberships/${applicationDetails._id}`)
      }
      hideLoading();
    }

  const ddModal = () => {
    setIsDdModalOpen(true)
  }

  const nextStepString = () => {
    if (!hardCrit) {
      if (nextStep === "No") {
        return <div>
          <p className="mb-2">We would like to stress that this is not a testament to your work, but simply a reflection of the interest in the program.</p>
          <p className="mb-2">We appreciate your understanding and wish you success in securing the support your company needs.</p>
          <p>Thank you,</p>
          <p className="mb-2">The ElevateIP Team</p>
          <p className="">www.elevate-ip.ca</p>
        </div>
      } else if (nextStep === "Later") {
        return <div>
        <p className="mb-2">While we understand that this is disappointing, we would like to encourage you to reconnect with ElevateIP as your path to commercialization progresses as opportunities for support may arise in the future.</p>
        <p className="mb-2">We appreciate your understanding and wish you success in securing the support your company needs.</p>
        <p className="mb-2">Thank you,</p>
        <p>The ElevateIP Team</p>
        <p className="">www.elevate-ip.ca</p>
      </div>
      }
    }
  }
  const emailPreview = () => {
    if (hardCrit) {
      return <div className="flex flex-col">
              <p className="mb-2">Thank you again for applying to ElevateIP.</p>
              <p className="mb-2">After a careful review of your application, your company did not meet the criteria required to be eligible to receive funding from ElevateIP. ElevateIP recipients must have less than 500 full time employees, be a CCPC (Canadian Controlled Private Corporation), and the IP needs to be owned by the corporation.</p>
              <p className="mb-2">We appreciate your interest in ElevateIP, and wish you the best of luck in securing the support your company needs.</p>
              <p className="mb-2">The ElevateIP Team</p>
              <p className="">www.elevate-ip.ca</p>
              <p className="mb-2">The ElevateIP Team</p>
            </div>
    } else {
      const reasonArray = []
      if (notTech) {
        reasonArray.push("The potential use or impact of your technology does not match the level of innovation of comparable applications.")
      }
      if (economicBenefit) {
        reasonArray.push("The anticipated overall economic and/or social benefit of your project scored lower than that of other applications.")
      }
      if (revScore) {
        reasonArray.push("The primary source of your revenue does not derive from your technology being developed or the time to commercialize the technology is longer compared to other applications.")
      }
      if (marketReadiness) {
        reasonArray.push("Given the early stage of your company, the path to production, or the status of your IP, the projected economic benefit does not match that of other applications.")
      }
      if (ipOwnership) {
        reasonArray.push("The IP in question does not belong to the organization, the ownership structure was unclear at the time of assessment, or the potential for the IP to be granted is lower than that of comparable applications.")
      }
      if (commercialization) {
        reasonArray.push("The IP to be secured is in a very early stage or the path to commercialization does not demonstrate the same capacity for growth and expansion compared to other applications.")
      }
      if (jobCreation) {
        reasonArray.push("Your company structure or projected impact on the labour market through this IP scores lower than other applications.")
      }
      if (teamFit) {
        reasonArray.push("Priorities or role distribution within your team are not as streamlined as team structures of comparable applications.")
      }
      return <div className="flex flex-col">
                <p className="mb-2 mt-2">Thank you again for applying to ElevateIP.</p>
                <p className="mb-2">After a careful review of your application, our assessment committee determined that your company's current status does not match the criteria sought for participation in ElevateIP as well as other applications.</p>
                <p className="mb-2">As the program is very competitive, we had to make the difficult call to decide against moving forward with your application. While this was not an easy decision, it was based on an assessment of various factors including, but not limited to:</p>
                {reasonArray.map((str, index) => (
                <p className="mb-2" key={index}>{str}</p>
              ))}
            </div>
    }
  }

  const personalFormModifier = () => {
    const formConts = document.getElementsByClassName('formComponentCont');
    if (formConts.length > 0) {
        formConts[0].classList.add('blockFormCont');
    }
    if (formConts.length > 1) {
        formConts[1].classList.add('blockFormCont');
    }
  }

  if (membershipApplicationDetailsAsync.status === "pending") {
    return <LoadingIndicator />;
  }

  if (membershipApplicationDetailsAsync.status === "rejected") {
    return <ErrorIndicator />;
  }
  
  const applicationDetails: T.ApplicationDetails = membershipApplicationDetailsAsync.value.applicationDetails;

  if (applicationDetails.ddObj) {

  }
//   const editRequest = async () => {
//     showLoading();
//     const res = await applicationEditRequest(applicationDetails?._id || "")
//     hideLoading();
//     if (res.success) {
//       showToast({
//         toastType: "success",
//         message: "Application Edit Requested",
//       });
//       navigate("/dashboard");
//     } else {
//       showToast({
//         toastType: "failure",
//         message: "Unable to update Statuses, lease try again.  If Error persists please conteact support",
//       });
//     }
//   }
    
//   const founderProfileGroupData = convertFounderProfileDBStateToUIState(applicationDetails.profileSnapshot);
//   if (founderProfileGroupData === null) {
//     throw new Error ("Founder Profile Does not exist")
//   } 

//   // Check if underrepresentedFounderGroups exists and includes specific values
//   const groups = founderProfileGroupData.programingEvaluation.underrepresentedFounderGroups as string[];
//   founderProfileGroupData.programingEvaluation.coPayEligible = false;  
//   if (groups && (groups.includes("women") || groups.includes("indigenous"))) {
//     founderProfileGroupData.programingEvaluation.coPayEligible = true;  
//   }

//   const viewPdf = (pdfName: string) => {
//     // setViewPdfName(pdfName)
//     setModalHTML(<div className="flex w-full min-w-full">
//     <PdfDownloader docKey={pdfName}/>
//    </div>)
//    setIsModalOpen(true)
//   }

//   const simplifyDocString = (docType: string ) => {
//     if (docType.includes("Pitch Deck")) {
//        return `${applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName} Pitch Deck`
//     }
// }

//   let docHtml = <></>

//   //OLD DOC RETREIVAL WILL NEED TO UPDATE FOR MORE DOCS ON APP I THINK
//   if (applicationDetails && applicationDetails.profileSnapshot.documents) {
//     const docs = applicationDetails.profileSnapshot.documents as {[key: string]: string;}
//     if (docs && docs._id) {
//       delete docs._id;
//     }
//     docHtml =
//     <div className="w-full flex flex-col">
//     {Object.keys(docs).map((key) => (
//         <button key={key} className="flex mt-2 items-center hover:underline" onClick={() => viewPdf(docs[key])}>
//           <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="13" height="16" viewBox="0 0 13 16" fill="none"><path d="M12.1253 4.96448V4.85029C12.1253 4.85029 12.1253 4.80514 12.1022 4.80514L12.0341 4.73698L6.36849 0.0230173H6.34547C6.34547 0.0230173 6.32245 0.0230174 6.30032 0H2.71948C1.22341 0 0 1.22341 0 2.71948V13.2805C0 14.7766 1.22341 16 2.71948 16H9.51819C11.0143 16 12.2377 14.7766 12.2377 13.2805V5.07693L12.1253 4.96448ZM6.45967 1.31547L10.4256 4.60151H7.13954C6.75445 4.60151 6.45967 4.30673 6.45967 3.92164V1.31547ZM9.40578 14.9811H2.60707C1.61028 14.9811 0.794081 14.1649 0.794081 13.1681V2.60703C0.794081 1.61025 1.61028 0.794045 2.60707 0.794045H5.55318V3.92164C5.55318 4.80511 6.25607 5.508 7.13954 5.508H11.2188V13.1681C11.2188 14.1649 10.4026 14.9811 9.40578 14.9811Z" fill="#1A2E25"/></svg>
//           {simplifyDocString(docs[key])}
//         </button>
//     ))}
//     </div>
    
//   }

  
  async function updateDd () {
    const ddObj = {
      cat1: cat1dd,
      cat2: cat2dd,
      cat3: cat3dd,
      cat4: cat4dd,
      cat5: cat5dd,
      cat6: cat6dd,
    }
    
    showLoading();
    const response = await updateMemberDd(ddObj, applicationDetails._id, false, ddNote);
    hideLoading();  
      if (response.success) {
        showToast({
          toastType: "success",
          message: "Due Diligence updated!",
        });
        navigate(`/dashboard/memberships/${applicationDetails._id}`);      }
    }

    async function saveDdResult () {
      const ddObj = {
        cat1: cat1dd,
        cat2: cat2dd,
        cat3: cat3dd,
        cat4: cat4dd,
        cat5: cat5dd,
        cat6: cat6dd,
      }
      showLoading();
      const response = await updateMemberDd(ddObj, applicationDetails._id, true, ddNote);
      hideLoading();  
      if (response.success) {
        showToast({
          toastType: "success",
          message: "Due Diligence completed!",
        });
        navigate(`/dashboard/memberships/${applicationDetails._id}`);
      }
    }

    async function saveRejectionProg () {
      showLoading();
      const response = await updatedRejectionProg(nextStep, hardCrit, notTech, economicBenefit, revScore, marketReadiness, ipOwnership, commercialization, jobCreation, teamFit, applicationDetails.userId);
      hideLoading();  
      if (response.success) {
        showToast({
          toastType: "success",
          message: "Rejection Progress Saved",
        });
        navigate(`/dashboard/memberships/${applicationDetails._id}`);
      }
    }

    async function sendRejectionEmail () {
      showLoading();
      const response = await rejectionEmailTrigger(nextStep, hardCrit, notTech, economicBenefit, revScore, marketReadiness, ipOwnership, commercialization, jobCreation, teamFit, applicationDetails.userId);
      hideLoading();  
      if (response.success) {
        showToast({
          toastType: "success",
          message: "Rejection Email Sent",
        });
        navigate(`/dashboard/memberships/${applicationDetails._id}`);
      }
    }

    const handleDdNote = (event: { target: { value: SetStateAction<string>; }; }) => {
      setDdNote(event.target.value);
    };

    const checkInProgDd = () => {
      if (applicationDetails.ddObj) {
      setCat1dd(applicationDetails.ddObj.cat1 ? applicationDetails.ddObj.cat1 : "")
      setCat2dd(applicationDetails.ddObj.cat2 ? applicationDetails.ddObj.cat2 : "")
      setCat3dd(applicationDetails.ddObj.cat3 ? applicationDetails.ddObj.cat3 : "")
      setCat4dd(applicationDetails.ddObj.cat4 ? applicationDetails.ddObj.cat4 : "")
      setCat5dd(applicationDetails.ddObj.cat5 ? applicationDetails.ddObj.cat5 : "")
      setCat6dd(applicationDetails.ddObj.cat6 ? applicationDetails.ddObj.cat6 : "") 
      }
    }
    if (checkDd === false) {
      setCheckDd(true)
      checkInProgDd()
    }
  return (
    <div className="resourcesCont !pt-0">
      {/* {isDdModalOpen &&
        <div className="flex flex-col w-full largeModal">
          <div className="flex flex-col w-full mediumModalInner">
            <div className='flex justify-end w-full'>
              <button onClick={() => setIsDdModalOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M1 1L9 9" stroke="#1A2E25" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>
            <div className="flex flex-col w-full">
              <label className=" my-2 font-semibold" htmlFor="cat1">Data Source Identified:</label>
              <select className="flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full" id="cat1" name="cat1" value={cat1dd} style={{wordWrap: "break-word"}} onChange={cat1Change}>
                <option value="fail">Fail</option>
                <option value="issue">Issue</option>
                <option value="pass">Pass</option>
                <option value="conditionalPass">Conditional Pass</option>
              </select>
            </div>
            <div className="flex flex-col w-full">
              <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="cat2">General Eligibility Check:</label>
              <select className="flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full" id="cat2" name="cat2" value={cat2dd} style={{wordWrap: "break-word"}} onChange={cat2Change}>
                <option value="fail">Fail</option>
                <option value="issue">Issue</option>
                <option value="pass">Pass</option>
                <option value="conditionalPass">Conditional Pass</option>
              </select>
            </div>
            <div className="flex flex-col w-full">
              <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="cat3">Best for Criteria:</label>
              <select className="flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full" id="cat3" name="cat3" value={cat3dd} style={{wordWrap: "break-word"}} onChange={cat3Change}>
                <option value="fail">Fail</option>
                <option value="issue">Issue</option>
                <option value="pass">Pass</option>
                <option value="conditionalPass">Conditional Pass</option>
              </select>
            </div>
            <div className="flex flex-col w-full">
              <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="cat4">No Conflict of Interest:</label>
              <select className="flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full" id="cat4" name="cat4" value={cat4dd} style={{wordWrap: "break-word"}} onChange={cat4Change}>
                <option value="fail">Fail</option>
                <option value="issue">Issue</option>
                <option value="pass">Pass</option>
                <option value="conditionalPass">Conditional Pass</option>
              </select>
            </div>
            <div className="flex flex-col w-full">
              <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="cat5">Security Checks:</label>
              <select className="flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full" id="cat5" name="cat5" value={cat5dd} style={{wordWrap: "break-word"}} onChange={cat5Change}>
                <option value="fail">Fail</option>
                <option value="issue">Issue</option>
                <option value="pass">Pass</option>
                <option value="conditionalPass">Conditional Pass</option>
              </select>
            </div>
            <div className="flex flex-col w-full ">
              <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="cat6">No Reputational Risk Found:</label>
              <select className="flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full" id="cat6" name="cat6" value={cat6dd} style={{wordWrap: "break-word"}} onChange={cat6Change}>
                <option value="fail">Fail</option>
                <option value="issue">Issue</option>
                <option value="pass">Pass</option>
                <option value="conditionalPass">Conditional Pass</option>
              </select>
            </div>
            <textarea className={`min-h-[112px] + ${inputClasses}`} defaultValue={ddNote} placeholder="Unless all criteria are marked pass, a note regarding the status is required" onBlur={handleDdNote}></textarea>
            <div className="w-full my-4 flex gap-4">
              <Button
                buttonText={"Save Progress"}
                actionHandler={() => updateDd()}
                disabled={ddNote === "" ? conditionalPassTrue ? false : failTrue ? false : issueTrue ? false : true : false }
              />
              {failTrue && 
                <Button
                buttonText={"Flag for Rejection"}
                actionHandler={() => saveDdResult()}
                />
              }              
              {cat1dd === "pass" && cat2dd === "pass" && cat3dd === "pass" && cat4dd === "pass" && cat5dd === "pass" && cat6dd === "pass" &&
                <Button
                  buttonText={"Submit Due Diligence"}
                  actionHandler={() => saveDdResult()}
                />
              }
              {conditionalPassTrue &&
                <Button
                  buttonText={"Growth Coach Follow-Up"}
                  actionHandler={() => saveDdResult()}
                  disabled={ddNote === ""}
                />
              }
            </div>
          </div>
        </div>
      }   */}
      {applicationDetails.status !== "rejectedFlagged" && applicationDetails.status !== "rejectedInProgress" && applicationDetails.status !== "rejected" && applicationDetails.status !== "rejectedReapply" 
      ?
      <div className="flex flex-col w-full">
        <h3>Due Diligence</h3>
        <div className="flex flex-col w-full">
          <div className="flex flex-col w-full">
            <label className="my-4 font-semibold bodyLarger" htmlFor="cat1">Data Source Identified:</label>
            <select className={`${inputClasses} flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full`} id="cat1" name="cat1" value={cat1dd} style={{wordWrap: "break-word"}} onChange={cat1Change}>
              <option disabled value=""></option>
              <option value="fail">Fail</option>
              <option value="issue">Issue</option>
              <option value="pass">Pass</option>
              <option value="conditionalPass">Conditional Pass</option>
            </select>
          </div>
          <div className="flex flex-col w-full">
            <label className="my-4 font-semibold bodyLarger" htmlFor="cat2">General Eligibility Check:</label>
            <select className={`${inputClasses} flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full`} id="cat2" name="cat2" value={cat2dd} style={{wordWrap: "break-word"}} onChange={cat2Change}>
              <option disabled value=""></option>
              <option value="fail">Fail</option>
              <option value="issue">Issue</option>
              <option value="pass">Pass</option>
              <option value="conditionalPass">Conditional Pass</option>
            </select>
          </div>
          <div className="flex flex-col w-full">
            <label className="my-4 font-semibold bodyLarger" htmlFor="cat3">Best for Criteria:</label>
            <select className={`${inputClasses} flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full`} id="cat3" name="cat3" value={cat3dd} style={{wordWrap: "break-word"}} onChange={cat3Change}>
              <option disabled value=""></option>
              <option value="fail">Fail</option>
              <option value="issue">Issue</option>
              <option value="pass">Pass</option>
              <option value="conditionalPass">Conditional Pass</option>
            </select>
          </div>
          <div className="flex flex-col w-full">
            <label className="my-4 font-semibold bodyLarger" htmlFor="cat4">No Conflict of Interest:</label>
            <select className={`${inputClasses} flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full`} id="cat4" name="cat4" value={cat4dd} style={{wordWrap: "break-word"}} onChange={cat4Change}>
              <option disabled value=""></option>
              <option value="fail">Fail</option>
              <option value="issue">Issue</option>
              <option value="pass">Pass</option>
              <option value="conditionalPass">Conditional Pass</option>
            </select>
          </div>
          <div className="flex flex-col w-full">
            <label className="my-4 font-semibold bodyLarger" htmlFor="cat5">Security Checks:</label>
            <select className={`${inputClasses} flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full`} id="cat5" name="cat5" value={cat5dd} style={{wordWrap: "break-word"}} onChange={cat5Change}>
              <option disabled value=""></option>
              <option value="fail">Fail</option>
              <option value="issue">Issue</option>
              <option value="pass">Pass</option>
              <option value="conditionalPass">Conditional Pass</option>
            </select>
          </div>
          <div className="flex flex-col w-full ">
            <label className="my-4 font-semibold bodyLarger" htmlFor="cat6">No Reputational Risk Found:</label>
            <select className={`${inputClasses} flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full`} id="cat6" name="cat6" value={cat6dd} style={{wordWrap: "break-word"}} onChange={cat6Change}>
              <option disabled value=""></option>
              <option value="fail">Fail</option>
              <option value="issue">Issue</option>
              <option value="pass">Pass</option>
              <option value="conditionalPass">Conditional Pass</option>
            </select>
          </div>
          <textarea className={`min-h-[112px] + ${inputClasses} my-6`} defaultValue={ddNote} placeholder="Unless all criteria are marked pass, a note regarding the status is required" onChange={handleDdNote}></textarea>
          <div className="w-full my-4 flex gap-4">
            <Button
              buttonText={"Save Progress"}
              actionHandler={() => updateDd()}
              disabled={ddNote === "" ? issueTrue === false && failTrue === false && conditionalPassTrue === false ? false : true : false}
            />
            {failTrue &&
              <Button
                buttonText={"Flag for Rejection"}
                actionHandler={() => saveDdResult()}
                disabled={ddNote === ""}
              />
            }              
            {cat1dd === "pass" && cat2dd === "pass" && cat3dd === "pass" && cat4dd === "pass" && cat5dd === "pass" && cat6dd === "pass" &&
              <Button
                buttonText={"Submit Due Diligence"}
                actionHandler={() => saveDdResult()}
              />
            }
            {conditionalPassTrue &&
              <Button
                buttonText={"Growth Coach Follow-Up"}
                actionHandler={() => saveDdResult()}
                disabled={ddNote === ""}
              />
            }
          </div>
        </div>
      </div>
      :
        <div className="flex flex-col w-full">
          <h3>Application Rejection </h3>
          <div className="flex flex-col w-full">
            <div className='flex justify-end w-full'>
              <button onClick={() => setIsRejectionlModalOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M1 1L9 9" stroke="#1A2E25" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>
          <div className="flex w-full flex-col">
            <h4 className="w-full">Next Steps:</h4>
            <div className="flex w-full my-2">
              <div className="flex bodyLarger">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={nextStep === "No"}
                    onChange={() => handleNextStepChange("No")}
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
              <label className="flex items-center h-full align-center">
                <input
                  type="checkbox"
                  checked={nextStep === "Later"}
                  onChange={() => handleNextStepChange("Later")}
                />
                <span className="ml-2">Later</span>
              </label>
              </div>
          </div>
          <div className="flex w-full flex-col">
            <h4 className="">Reasoning:</h4>
              <div className="w-full inline-flex flex-wrap">
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={hardCrit}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("hardCrit")}
                    />
                    <span className="ml-2">Hard Criteria</span>
                  </label>
                </div>
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={notTech}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("notTech")}
                    />
                    <span className="ml-2">Not Technology</span>
                  </label>
                </div>
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={economicBenefit}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("economicBenefit")}
                    />
                    <span className="ml-2">Economic Benefit</span>
                  </label>
                </div>
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={revScore}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("revScore")}
                    />
                    <span className="ml-2">Revenue Source</span>
                  </label>
                </div>
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={marketReadiness}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("marketReadiness")}
                    />
                    <span className="ml-2">Market Readiness</span>
                  </label>
                </div>
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={ipOwnership}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("ipOwnership")}
                    />
                    <span className="ml-2">IP Ownership</span>
                  </label>
                </div>
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={commercialization}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("commercialization")}
                    />
                    <span className="ml-2">Commercialization</span>
                  </label>
                </div>
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={jobCreation}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("jobCreation")}
                    />
                    <span className="ml-2">Job Creation</span>
                  </label>
                </div>
                <div className="flex bodyLarger my-2">
                  <label className="flex items-center h-full align-center">
                    <input
                      type="checkbox"
                      checked={teamFit}
                      disabled={nextStep === ""}
                      onChange={() => changeCriteria("teamFit")}
                    />
                    <span className="ml-2">Team Fit</span>
                  </label>
                </div>
              </div>
          </div>
          <h4>Email Preview:</h4>
          {nextStep !== "" &&
            <div className="flex flex-col w-full bodyLarger">
              {emailPreview()}
              {nextStepString()}
            </div>
          }
          <div className="w-full my-4 flex gap-4">
            <Button
              buttonText={"Save Rejection Progress"}
              actionHandler={() => saveRejectionProg()}
              buttonType="primaryFull"
              disabled={nextStep === ""}
            />
            <Button
              buttonText={"Send Rejection Email Now"}
              actionHandler={() => sendRejectionEmail()}
              buttonType="primaryFull"
              disabled={!hardCrit && !notTech && !economicBenefit && !revScore && !marketReadiness && !ipOwnership && !commercialization && !jobCreation && !teamFit}
            />
          </div>
        </div>
      </div>
      }
      {/* <div className="w-full">
        <div className="">
          <h3>Review Application</h3>
          <h3 className="font-semibold mb-8">{applicationDetails.profileSnapshot.companyInfo?.basicInfo?.operatingName}</h3>
        </div>
          <div className="flex flex-wrap just">
            <div className="inline-flex flex-col applicationFormWidth">
                {
                applicationDetails.flaggedNote && 
                  <div className="flex flex-col text-text applicationFormWidth mb-3 ">      
                    <p>{applicationDetails.flaggedNote}</p>
                  </div>
                }
                <Form
                  formDefinition={profileFormPersonalInfoDefinition}
                  formData={applicationDetails.profileSnapshot.personalInfo}
                  readOnly
                  disabled
                  modifierFunc={personalFormModifier}
                />
                <h4 className="mb-6 mt-8">{textData.Pages.FounderPages.FounderProfile.CompanyInfo[langState]}</h4>
                <Form
                  formDefinition={profileFormCompanyInfoDefinition}
                  formData={applicationDetails.profileSnapshot.companyInfo === null ? null : companyInfoToForm(applicationDetails.profileSnapshot.companyInfo)}
                  readOnly
                />
                <h4 className="mb-6 mt-8">{textData.Pages.FounderPages.FounderProfile.Readiness[langState]}</h4>
                <Form
                  formDefinition={profileFormiPStrategyDefinition}
                  formData={applicationDetails.profileSnapshot.iPStrategy}
                  readOnly
                  disabled
                />
                { applicationDetails.profileSnapshot.ipReadiness &&
                <div>
                  <h4 className="mb-6 mt-8">{textData.Pages.FounderPages.FounderProfile.ServiceEval[langState]}</h4>
                    <Form
                      formDefinition={profileFormipReadinessDefinition}
                      formData={applicationDetails.profileSnapshot.ipReadiness}
                      readOnly
                      disabled
                   />
                </div>
                } 
                <h4 className="mb-6 mt-8">{textData.Pages.FounderPages.FounderProfile.ServiceEval[langState]}</h4>
                <Form
                  formDefinition={adminProfileFormProgramingEvaluationDefinition}
                  formData={founderProfileGroupData.programingEvaluation}
                  readOnly
                  disabled
                />
              </div>
              
              <div className="mb-6">
                <div className="appDetailsScoringCont">
                  {applicationDetails.applicationScore &&          
                  <div>
                    {applicationDetails?.profileSnapshot.ipPreScore && applicationDetails?.profileSnapshot.applicationScore &&
                      <h4 className="font-semibold mt-4">Total Score: {applicationDetails?.profileSnapshot.ipPreScore?.totalScore + applicationDetails?.profileSnapshot.applicationScore?.totalScore}</h4>
                    }
                    {applicationDetails && applicationDetails.profileSnapshot.ipPreScore === undefined && applicationDetails?.profileSnapshot.applicationScore &&
                      <h4 className="font-semibold mt-4">Total Score: {applicationDetails?.profileSnapshot.applicationScore?.totalScore}</h4>
                    }
                    <div className="flex flew-wrap w-full">
                      <div className="flex flex-col text-text w-1/2 mb-3">
                        <p className="bodyLarger">Persona Score: {applicationDetails.applicationScore?.totalScore}</p>
                        <ul className="small">
                          <li>Classification: {applicationDetails.applicationScore?.classification}</li>
                          <li>Age Score: {applicationDetails.applicationScore?.age}</li>
                          <li>Revenue Score: {applicationDetails.applicationScore?.revenue}</li>
                          <li>Employee Score: {applicationDetails.applicationScore?.fte}</li>
                        </ul>
                      </div> 
                      {applicationDetails?.profileSnapshot.ipPreScore &&            
                      <div className="flex flex-col text-text w-1/2 mb-3">
                        <p className="bodyLarger">IP PreScore: {applicationDetails.ipPreScore?.totalScore}</p>
                        <ul className="small">
                          <li>IP Readiness - Patents: {applicationDetails.ipPreScore?.ipReadinessPatents}</li>
                          <li>IP Readiness - General: {applicationDetails.ipPreScore?.ipReadinessGeneral}</li>
                        </ul>
                      </div>
                      }
                    </div>
                  </div>
                  }
                   <div className="flex flex-col w-full">
                      <p className="bodyLarger font-semibold w-full">Files</p>
                      {docHtml}
                    </div>
                    <div className="flex flex-col gap-4">
                      {applicationDetails.status !== "rejectedFlagged" && applicationDetails.status !== "rejectedInProgress" && applicationDetails.status !== "rejected" && applicationDetails.status !== "rejectedReapply" ?
                      <Button 
                        buttonText="Due Diligence"
                        actionHandler={() => checkInProgDd()}
                      />
                      :
                      <Button
                        buttonText={"Decline Application"}
                        actionHandler={() => setIsRejectionlModalOpen(true)}
                      />
                      }
                      <Button         
                        buttonType="primaryFull"
                        buttonText="Request Application Edit"
                        actionHandler={ () => {
                          editRequest()
                        }}
                      />
                    </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <Modal 
            isOpen={isModalOpen}
            closeModal={() => closeModal()}
            modalHeader={viewPdfName}
            contentLabel={viewPdfName} // [TODO]
            fullWidth={true}
            modalHTML={modalHTML}
            style={{
              content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                minWidth: '75%',
                maxWidth: '75%',
                maxHeight: '90%',
                width: 'full',
                background: "background",
              }
            }}
          /> */}
      </div>
  )
}

export default MemberApplicationDetail
